import $ from "jquery";
import users from "./devUsers";
import {devUserOptions} from './devUsers'
import { serialize } from 'object-to-formdata'
import Resizer from "react-image-file-resizer"
import {levenshteinEditDistance} from 'levenshtein-edit-distance'
import ukkonen from 'ukkonen'

export const nMap = (n,cb)=>{
  const result = []
  for(let i = 0; i < n; i++){
    result.push(cb(i))
  }
  return result
}

export const removeNonNumeric = s => s.replace(/[^\d.-]/g, '')

export function dataURLtoFile(dataurl, filename) {

  var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), 
      n = bstr.length, 
      u8arr = new Uint8Array(n);
      
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  
  return new File([u8arr], filename, {type:mime});
}

export const validateImageSize = ({file,dims,success,fail})=>{
  const _URL = window.URL || window.webkitURL
  const img = new Image()
  const objectUrl = _URL.createObjectURL(file)
  img.onload = function () {
    const width = this.width
    const height = this.height
    const validSize = (
      parseInt(width) === parseInt(dims.w)
      &&
      parseInt(height) === parseInt(dims.h)
    )
    _URL.revokeObjectURL(objectUrl)
    if (validSize) success()
    else fail(width,height)
  }
  img.src = objectUrl
}

export const resizeImage = ({file,dims,success})=>{
  const _URL = window.URL || window.webkitURL
  const img = new Image()
  const objectUrl = _URL.createObjectURL(file)
  img.onload = function() {
    const width = dims.w
    const height = dims.h
    var canvas = document.createElement('canvas'),
    ctx = canvas.getContext("2d"),
    oc = document.createElement('canvas'),
    octx = oc.getContext('2d');

    canvas.width = width; // destination canvas size
    canvas.height = canvas.width * img.height / img.width;

    var cur = {
      width: Math.floor(img.width * 0.5),
      height: Math.floor(img.height * 0.5)
    }

    oc.width = cur.width;
    oc.height = cur.height;

    octx.drawImage(img, 0, 0, cur.width, cur.height);

    while (cur.width * 0.5 > width) {
      cur = {
        width: Math.floor(cur.width * 0.5),
        height: Math.floor(cur.height * 0.5)
      };
      octx.drawImage(oc, 0, 0, cur.width * 2, cur.height * 2, 0, 0, cur.width, cur.height);
    }

    ctx.drawImage(oc, 0, 0, cur.width, cur.height, 0, 0, canvas.width, canvas.height);
    canvas.toBlob((blob) => {
      const file = new File([blob], "fileName.jpg", { type: "image/jpeg" })
      success(file)
    }, 'image/jpeg');

  }
  img.src = objectUrl
}

export const resizeFile = (file,w,h) => new Promise((resolve) => {
  Resizer.imageFileResizer(
    file,
    w,
    h,
    "JPEG",
    100,
    0,
    (blob) => {
      resolve(blob);
    },
    "blob"
  )
})

/**
 * STRING MUST BE FIRST ARGUMENT 
 * Takes a query string and slides it over a string and calculates
 * the edit distance. Eg:
 * this is a test string to query
 * -------|aatest|------
 * This would result in a minimum edit distance of 1 and an offset of 8
 */
export const slidingEditDistance = (string,query)=>{
  //check if there is an exact match
  if (string.toLowerCase() === query.toLowerCase()) return {dist:0,offset:0}
  if (string.toLowerCase().includes(query)){
    return {dist:0,offset:string.toLowerCase().indexOf(query.toLowerCase())}
  }
  const splitQuery = query.split(' ').filter(s=>Boolean(s))
  const hasAll = splitQuery.reduce((carry,q)=>carry&&string.toLowerCase().includes(q.toLowerCase()),true)

  if (hasAll){ 
    const avgOffset = splitQuery
      .map(
        q=>string.toLowerCase().indexOf(q.toLowerCase())
      )
      .reduce((t,o)=>t+0,0)/splitQuery.length
    return {dist:0.1/splitQuery.length,offset:avgOffset}
  }
  //check if each word in the query exists in each word in the string
  string = String(string).toLowerCase()
  query = String(query).toLowerCase()
  if (string.length<query.length) {
    return {dist:levenshteinEditDistance(string,query),offset:0}
  }
  const buffer = 2
  const L = query.length + buffer
  const distanceThreshold = 3
  let min = Math.min(string.length,query.length)
  let offset = min
  for (let i = 0; i < string.length - query.length + 1; i++) {
    const sub = string.substring(i,query.length+i)
    //if first character is a match
    const matchesStart = sub.charAt(0).toLowerCase() === query.charAt(0).toLowerCase()
    const dist = (
      matchesStart
      ? ukkonen(sub,query,distanceThreshold)
      : string.length
    )
    if(dist<min) offset = i
    min = Math.min(min,dist)
  }
  return {dist:min,offset}
}

//Used to compare two strings against query using the sliding edit distance
//if two strings have the same edit distance which ever string has the match
//closest to the beginning will be ranked first
export const slidingQueryComparision = (a,b,q)=>{
  const {dist:aDist,offset:aOffset} = slidingEditDistance(a,q)
  const {dist:bDist,offset:bOffset} = slidingEditDistance(b,q)
  const alphabetical = a < b ? -1 : 1
  return aDist - bDist || aOffset - bOffset || alphabetical 
}

export const userIsOwner = user => (
  (parseInt(user.gym_id) !== 0 && user.account_type==='gym') ||
  (parseInt(user.gym_id) === 0 && user.account_type==='trainer')
)

export const getAccountOwner = user => {
  if(parseInt(user.gym_id)!==0) return parseInt(user.gym_id)
  if(user.account_type==='trainer') return parseInt(user.user_id_number)
  return parseInt(user.user_trainer_id) || parseInt(user.trainer_id)
}


export const resourceTypeDisplayText = type => {
  switch(type){
    case "merchandise_item": return 'Product'
    case "custom_form": return 'Form'
    default: return type.split('_').map(capitalize).join(' ')
  }
}

/**
  * copies input string to the clipboard
  *
  * @param {string} newClip   string to copy
  */
export const copyToClipboard = (newClip)=>{
  //https://developer.mozilla.org/en-US/docs/Mozilla/Add-ons/WebExtensions/Interact_with_the_clipboard
  navigator.clipboard.writeText(newClip)
}

// export const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);
export const capitalize = s => s && `${s.charAt(0).toUpperCase()}${s.slice(1)}`

//Legacy routing had inconsistent paramters for different routes
//this helper shunts the legacy inconsistency here so that route
//param "consumers" can have consistent structure. 
export const extractEventParams = (search)=>{
  const urlParams = new URLSearchParams(search)
  //parse selector to be one of workout,task, nutrition
  const selector = urlParams.get('selector')?.toLowerCase()

  //some routes used things like selector=Workouts whereas others have eventType = workout
  //and others have selector = AddOrEdit
  const eventType = (
    (selector&&selector!=='addoredit') ?
    selector === 'nutrition' || selector === 'all' ? selector : selector.slice(0,-1) :
    urlParams.get('eventType')?.toLowerCase()
  )
  //get the display param or default to all
  const display = (urlParams.get('display') || 'all')?.toLowerCase()
  const filter = (urlParams.get('filter') || 'favorite')?.toLowerCase()
  const client_id = urlParams.get('client')
  const event_id = urlParams.get('event_id')
  const trainer_id = urlParams.get('trainer_id')
  const origin = urlParams.get('origin')
  const calendarEventType = urlParams.get('calendarEventType')
  const view = urlParams.get('view');
  return {eventType,display,filter,client_id,event_id,origin,trainer_id, calendarEventType, view}
}

export const getTrainerParam = ()=>{
	const url = new URL(window.location.href)
	const params = new URLSearchParams(url.search);
	return params.get('trainer')
}

//rounds a number to specified precision of decimal places
export const prettyRound = (n,p)=>{
  n = parseFloat(n)
  return (
    parseInt(n.toFixed(0)) === parseFloat(n.toFixed(p))
    ? n.toFixed(0)
    : n.toFixed(p)
  )
}

export const ellipsis = (s,m)=> s.length > m ? `${s.charAt(0).toUpperCase()}${s.slice(1,m)}...` : s

const prependZero = n => n < 10 ? `0${n}` : n

export const dateToYMD = date => `${date.getFullYear()}-${prependZero(date.getMonth()+1)}-${prependZero(date.getDate())}`

export const getRoundedDate = (minutes, d=new Date()) => {
  const ms = 1000 * 60 * minutes;
  const roundedDate = new Date(Math.round(d.getTime() / ms) * ms);
  return roundedDate
}

export const dateToAPIStandard = date =>(
	//get YYYY-MM-DD HH:MM:SS from date object
	`${
		date.getFullYear()+'-'+prependZero(date.getMonth()+1)+'-'+prependZero(date.getDate())
	} ${
		prependZero(date.getHours())+':'+prependZero(date.getMinutes())+':'+prependZero(date.getSeconds())
	}`
)

const addTrainerParam = (urlString,trainer_id)=>{
	if(!trainer_id) return urlString
	const url = new URL(urlString)
	const params = new URLSearchParams(url.search)
	//don't do anyting if trainer string already present
	if(params.has('trainer')) return urlString
	params.append('trainer',trainer_id)
	params.append('trainerID',trainer_id)
	params.append('trainer_id',trainer_id)
	return `${url.href}?${params.toString()}`
}

export const envAwareFormSubmit = (opts)=>{
	const payload = opts.payload || {}
	let path = opts.path
  path = path.replace('.php','')
  //if on localhost
  const isLocal = window.location.host.indexOf('localhost') > -1
  //if in react dev server
  const isDev = window.location.host.indexOf('localhost:') > -1
  if(path.slice(-1) !== "/"){
    path = `${path}/`
  } 
  const urlString = (
    isLocal
    ? `http://localhost/${path}`
    : `https://${window.location.host}/${path}`
  )
	const postData = (
		//if not dev set postData to payload
		//otherwise add dev parameters so that react dev
		//environment can interact with local apache server
		!isDev ? payload :
		{
			mobile:1,
      platform:'web',
			...users[devUserOptions.selectedUser],
			...payload
		}
	)
	const fd = serialize(postData)

	const endpoint = addTrainerParam(urlString,getTrainerParam())
	return $.ajax({
		url:endpoint,
		method: 'POST',
		type:'post',
		cache: false,
		data: fd,
		processData: false,
		contentType: false
	}).then(res=>{
		//console.log(res)
		return JSON.parse(res)
	})
}

// provide own login info 
export const envAwarePostAddLogin = (path,payload)=>{
  path = path.replace('.php','')
  //if on localhost
  const isLocal = window.location.host.indexOf('localhost') > -1
  //if in react dev server
  const isDev = window.location.host.indexOf('localhost:') > -1
  if(path.slice(-1) !== "/"){
    path = `${path}/`
  } 
  const urlString = (
    isLocal?
    `http://localhost/${path}`:
    `https://${window.location.host}/${path}`
  )
  const endpoint = addTrainerParam(urlString,getTrainerParam())
  const postData = (
    isDev ?
    {
      mobile:1,
      ...payload
    } :
    {
      ...payload
    }
  )

  return $.post(
    endpoint,
    postData
  ).then(res => {

    return JSON.parse(res)
  })
}

export const envAwarePost = (path,payload)=>{
  //strip php from paths
  path = path.replace('.php','')
  //if on localhost
  const isLocal = window.location.host.indexOf('localhost') > -1
  //if in react dev server
  const isDev = window.location.host.indexOf('localhost:') > -1
  if(path.slice(-1) !== "/"){
    path = `${path}/`
  } 
  const urlString = (
    isLocal?
    `http://${window.location.hostname}/${path}`:
    `https://${window.location.host}/${path}`
  )
  const endpoint = addTrainerParam(urlString,getTrainerParam())
  const postData = (
    isDev ?
    {
      platform:'web',
      ...users[devUserOptions.selectedUser],
      mobile:1,
      ...payload
    } :
    {
      platform:'web',
      ...payload
    }
  )

  return $.post(
    endpoint,
    postData
  ).then(res => {
    const data = JSON.parse(res)
    return data
  })
}

export const fullBasePath = () =>(
  window.location.host.indexOf("localhost") > -1
    ? "http://localhost"
    : "https://" + window.location.host
)

export const isValidHttpUrl = (string) => {
  let url;
  
  try {
    url = new URL(string);
  } catch (_) {
    return false;  
  }

  return url.protocol === "http:" || url.protocol === "https:";
}
